export default "__VITE_ASSET__DUjoLn6f__"